import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/array';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './styles/styles.css';

import App from './App';
import { appModel } from './app/appModel';

ReactDOM.render(<App model={appModel} />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx